/**
 * Строка `detail` из JSON-тела ответа с ошибкой; `null`, если тело не
 * JSON или `detail` не строка (например, список ошибок валидации).
 */
export async function readErrorDetail(
  response: Response,
): Promise<string | null> {
  try {
    const body = (await response.json()) as { detail?: unknown };
    return typeof body.detail === "string" ? body.detail : null;
  } catch {
    return null;
  }
}
